// This function exist to prevent schedule.raw.group to be set to non-array accidentally
// Because other places in the code assumes that schedule.raw.group is always array
const getNewGroup = availabilityInTimestampArray => {
  if (availabilityInTimestampArray && availabilityInTimestampArray[0]) {
    const finalAvailabilityInTimestampArray = availabilityInTimestampArray.map(o => {
      if (o.raw && o.raw.group[0]) {
        return o.raw.group;
      }

      return [];
    }).filter(gr => gr.length > 0)[0] || [];
    return finalAvailabilityInTimestampArray;
  }

  return [];
};

export default getNewGroup;